import React from 'react';
import './ModemDetails.css';
import '../../i18n';
import { useTranslation } from 'react-i18next';

import L9g20_1 from "../../assets/images/l9g20/L-9g20-1.png";

const L9g20_SPEC = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="spec-container">
      <div className="spec-header-image">
        <img src={L9g20_1} className="spec-header-image-img" />
      </div>

      <div className="spec-item full-width">
        <h2 className="spec-title">{t('accessoires.l9g20.details.title')}</h2>
        <ul className="spec-details">
          <li>{t('accessoires.l9g20.details.p1')}</li>
          <li>{t('accessoires.l9g20.details.p2')}</li>
          <li>{t('accessoires.l9g20.details.p3')}</li>
          <li>{t('accessoires.l9g20.details.p4')}</li>
          <li>{t('accessoires.l9g20.details.p5')}</li>
          <li>{t('accessoires.l9g20.details.p6')}</li>
          <li>{t('accessoires.l9g20.details.p7')}</li>
        </ul>
      </div>

    </div>
  );
};

export default L9g20_SPEC;
